import React from "react";
import {
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography,
  FormGroup,
  Box,
  Button,
} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import Stack from "@mui/material/Stack";
import { Facebook, Google, Twitter } from "@mui/icons-material";
import Link from "@mui/material/Link";
import Avatar from "@mui/material/Avatar";
import shadows from "@mui/material/styles/shadows";
import { alpha } from "@mui/material/styles";
import { auth } from "@jumbo/services/auth/firebase/firebase";
import * as yup from "yup";
import { Form, Formik } from "formik";
import { useAuthSignInWithEmailAndPassword } from "@react-query-firebase/auth";
import LoadingButton from "@mui/lab/LoadingButton";
import { useHistory } from "react-router-dom";
import Div from "@jumbo/shared/Div";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import { useJumboApp } from "@jumbo/hooks";
import { LAYOUT_NAMES } from "../../../layouts/layouts";
import { ASSET_AVATARS, ASSET_IMAGES } from "../../../utils/constants/paths";
import { getAssetPath } from "../../../utils/appHelpers";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import axios from "axios";
import { useDispatch } from "react-redux";
import { fetchError } from "../../../redux/actions/Common";

import {
  onActualizarOtp,
  onConsultarCI,
  onEnviarOtpSms,
  validarCelular,
} from "../services/index";

import { grabarAceptacion } from "../../app-evaluacion/services/evaluacionServices";
import { userPhotos } from "app/shared/widgets/UserPhotos/data";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  consultarGrupoGenerico,
  obtenerRegistroGrupo,
} from "app/modules/app-configuracion/services/configuracionServices";
import HouseIcon from "@mui/icons-material/House";
import FormContactoCliente from "app/modules/app-cliente/components/FormContactoCliente";
import {
  consultaContacto,
  crearCliente,
  grabarClienteOrquestacion,
} from "app/modules/app-cliente/services/clienteService";
import { consultarFechaSistema } from "app/modules/shared/services/sheredServices";

import { useOnLogout } from "app/modules/app-auth/hook";

const validationSchema = yup.object({
  celular: yup
    .string("Ingrese Celular")
    .required("Celular es Obligatorio")
    .matches(
      /^[0]{1}[1-9]{2}[0-9]{3}[0-9]{4}$/i,
      "Ingresa un número de celular válido (10 dígitos)",
    ),
  email: yup
    .string("Ingrese su email")
    .email("Ingrese email válido")
    .required("Email es obligatorio"),
  cedula: yup.string("Ingrese Cédula").required("Cédula es Obligatorio"),
});

const Welcome1 = () => {
  const dispatch = useDispatch();
  const [state, setState] = React.useState({
    uno: false,
    dos: false,
    tres: false,
  });

  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const { uno, dos, tres } = state;
  const error = [uno, dos, tres].filter((v) => v).length !== 3;

  const origen = localStorage.getItem("origen");
  const idGrupo = localStorage.getItem("idGrupoStorage");
  //localStorage.setItem('origen', origen);

  const [color, setColor] = useState("");
  const [url, setUrl] = useState("");
  //const [idCliente, setIdCliente] = useState(0);

  const [idClienteInformacion, setIdClienteInformacion] = useState(-1);
  const [idClienteAux, setIdClienteAux] = useState(null);

  const history = useHistory();
  const { setActiveLayout } = useJumboApp();
  const { authUser } = useSelector(({ auth }) => auth);
  const [sendLogout, setSendLogout] = useState(false);
  const [userCode, setUserCode] = useState(false);
  const [nombreOtp, setNombreOtp] = useState("");
  useOnLogout(userCode, sendLogout, setSendLogout);

  React.useEffect(() => {
    setUserCode(authUser.key);
    setActiveLayout(LAYOUT_NAMES.SOLO_PAGE);
    switch (origen) {
      case "tvtas":
        setColor("#FF9201");
        setUrl("https://www.tventas.com/content/55-creditventas");
        break;
      case "corpfav":
        setColor("#e1251b");
        setUrl("https://www.creditofavorito.com/");
        break;
      default:
        setColor("#e1251b");
        setUrl("https://www.creditofavorito.com/");
        break;
    }
    const obtenerGrupo = async () => {
      const resp = await consultarGrupoGenerico(origen, 1);
      if (resp.state) {
        localStorage.setItem("idGrupoStorage", resp.data[0].codigo);
      } else {
        console.log(resp.message);
      }
    };

    getDatos();
    obtenerGrupo();
  }, []);

  // React.useEffect(() => {
  //   console.log(idClienteInformacion);
  //   //debugger;
  //   //setIdClienteInformacion(idClienteAux);
  //   if (idClienteInformacion > 0) {
  //     setIdClienteInformacion(idClienteInformacion);
  //     //setIdClienteAux(idClienteInformacion);
  //   }
  // }, [idClienteInformacion]);

  React.useEffect(() => {
    if (idClienteInformacion > 0) {
      console.log("Cliente actualizado:", idClienteInformacion);
    }
  }, [idClienteInformacion]);

  const getDatos = async () => {
    //debugger
    let tipocliente = localStorage.getItem("tipocliente");
    let cedula = localStorage.getItem("cedula");
    if (tipocliente == "NUEVO") {
      const datosPersona = await onConsultarCI(cedula);

      localStorage.setItem("cd", datosPersona.data.codigoDactilar);

      let apellidos =
        datosPersona.data.primerApellido +
        " " +
        datosPersona.data.segundoApellido;
      let nombres =
        datosPersona.data.primerNombre + " " + datosPersona.data.segundoNombre;

      localStorage.setItem("ap", apellidos);
      localStorage.setItem("nm", nombres);

      setNombreOtp(
        datosPersona.data.primerNombre + " " + datosPersona.data.primerApellido,
      );

      let today = null;
      const srvFecha = await consultarFechaSistema();
      if (srvFecha.state) {
        today = srvFecha.data.fechaHora;
      } else {
        today = new Date().toLocaleString("en-US");
      }

      if (datosPersona.data.idCliente > 0) {
        setIdClienteInformacion(datosPersona.data.idCliente);
      } else {
        const clienteInfo = datosPersona.data;

        const informacionCliente = {
          idCliente: Number(
            `${clienteInfo.idCliente <= 0 ? 0 : clienteInfo.idCliente}`,
          ),
          idGrupo: 1,
          identificacion: cedula,
          tipoIdentificacion: clienteInfo.tipoIdentificacion || "CI",
          naturaleza: clienteInfo.naturaleza ?? "PERS01",

          perfilRiesgo: clienteInfo.perfilRiesgo ?? "",
          tipoCliente: clienteInfo.tipoCliente ?? "",
          score: clienteInfo.score ?? 0,
          origen: clienteInfo.origen ?? "",
          actualizado: clienteInfo.actualizado ?? false,
          esActivo: true,

          fechaCreacion: today,
          usuarioCreacion: authUser.key,
          estacionCreacion: authUser.estacion,
          fechaModificacion: today,
          usuarioModificacion: authUser.key,
          estacionModificacion: authUser.estacion,
        };

        //console.log({ informacionCliente });

        const informacionDemografica = {
          primerNombre: clienteInfo.primerNombre.toUpperCase().trim(),
          primerApellido: clienteInfo.primerApellido.toUpperCase().trim(),
          segundoNombre: clienteInfo.segundoNombre.toUpperCase().trim(),
          segundoApellido: clienteInfo.segundoApellido.toUpperCase().trim(),
          estadoCivil: clienteInfo.estadoCivil,
          fechaNacimiento: clienteInfo.fechaNacimiento,
          genero: clienteInfo.genero,
          nacionalidad: clienteInfo.nacionalidad,
          nivelInstruccion: clienteInfo.nivelInstruccion,
          razonSocial: clienteInfo.razonSocial.toUpperCase(),
          nombreComercial: clienteInfo.nombreComercial.toUpperCase().trim(),
          codigoDactilar: clienteInfo.codigoDactilar.toUpperCase().trim(),
          fechaIdentificacion: clienteInfo.fechaIdentificacion,
          esFallecido: clienteInfo.esFallecido ?? false,
          esActivo: true,

          fechaCreacion: today,
          usuarioCreacion: authUser.key,
          estacionCreacion: authUser.estacion,
        };

        const informacionOrquestacion = {
          cliente: { ...informacionCliente },
          demografica: { ...informacionDemografica },
        };

        const respuestaClienteOrquestacion = await grabarClienteOrquestacion(
          informacionOrquestacion,
        );
        if (respuestaClienteOrquestacion.state) {
          setIdClienteInformacion(respuestaClienteOrquestacion.data);
        } else {
          console.log(respuestaClienteOrquestacion.message);
        }
      }
    }
  };

  function generate_uuidv4() {
    var dt = new Date().getTime();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var rnd = Math.random() * 16; //random number in range 0 to 16
        rnd = ((dt + rnd) % 16) | 0;
        dt = Math.floor(dt / 16);
        return (c === "x" ? rnd : (rnd & 0x3) | 0x8).toString(16);
      },
    );
  }

  const mutation = useAuthSignInWithEmailAndPassword(auth, {
    onError(error) {
      console.log(error);
    },
    onSuccess(data) {
      history.push("/");
    },
  });

  const onSaveDctosCF = async (cedula, mail) => {
    debugger;
    let user = JSON.parse(sessionStorage.getItem("user"));

    const result = await axios.get("https://api.ipify.org");
    let ipAdress = result.data;

    //let ipAdress = generate_uuidv4();
    let datos = {
      identificacion: cedula,
      idGrupo: parseInt(idGrupo),
      fechaConsulta: new Date(), //"6/28/2023, 5:26:31 PM",
      usuario: user.key,
      estacion: ipAdress,
      enviaDatos: false,
      tcu: true,
      ppr: true,
      bur: true,
      esCliente: true,
      documentosFirmados: false,
      email: mail,
    };

    let response = await grabarAceptacion(datos);
    if (!response.state) {
      alert(response.message);
    }
  };

  const onSignIn = async (cedula) => {
    debugger;
    // let tipocliente = localStorage.getItem("tipocliente");
    // if (tipocliente == "NUEVO") {
    //   const datosPersona = await onConsultarCI(cedula);
    //   localStorage.setItem("cd", datosPersona.data.codigoDactilar);

    //   let apellidos =
    //     datosPersona.data.primerApellido +
    //     " " +
    //     datosPersona.data.segundoApellido;
    //   let nombres =
    //     datosPersona.data.primerNombre + " " + datosPersona.data.segundoNombre;

    //   localStorage.setItem("ap", apellidos);
    //   localStorage.setItem("nm", nombres);

    //   //debugger;
    //   //history.push("/auth-pages/datos");
    // }

    //obtener datos de contacto

    debugger;
    const srvObtenerContacto = await consultaContacto(
      idClienteInformacion,
      "DIRDOM",
    );
    if (srvObtenerContacto.state) {
      const datosContacto = srvObtenerContacto.data;
      const srvValidarCelular = await validarCelular(
        cedula,
        datosContacto.celular,
        localStorage.getItem("idGrupoStorage"),
      );

      if (srvValidarCelular.state) {
        let response = await onActualizarOtp(datosContacto.email, cedula);
        if (response.state) {
          history.push("/auth-pages/otpregistro");
          debugger;
          let nombres = nombreOtp;
          //console.log("otp");
          //envia otp celular
          onEnviarOtpSms(nombres, response.data, datosContacto.celular, cedula, localStorage.getItem("idGrupoStorage"));

          //graba datos corporacion
          localStorage.setItem("cedula", cedula);
          localStorage.setItem("email", datosContacto.email);
          localStorage.setItem("celular", datosContacto.celular);

          onSaveDctosCF(cedula, datosContacto.email);
        } else {
          //alert(response.message);
          dispatch(fetchError(response.message));
        }
      } else {
        alert(srvValidarCelular.message);
        try {
          const respGrupo = await obtenerRegistroGrupo(
            localStorage.getItem("idGrupoStorage"),
          );
          if (respGrupo.state) {
            url = respGrupo.data.portal;
          }
        } catch (e) {
          console.log(e);
        }
        setSendLogout(true);
        window.opener = null;
        window.open(url, "_self");
        window.close();
      }
    } else {
      alert("Debe grabar los datos de contacto.");
      console.log(srvObtenerContacto.message);
    }
  };

  const handleRedirect = () => {
    /*     setSend(false);
    setMostrarRefresh(false);
    setesperaLogin(false);
    setLoggedUser(false);
    localStorage.removeItem("tipocliente");
    localStorage.removeItem("idGrupoStorage");
    localStorage.removeItem("cedula");
    localStorage.removeItem("origen"); */

    const urlAutoservice = process.env.REACT_APP_URL_AUTOSERVICE;

    if (localStorage.getItem("station") === "autosrv") {
      setSendLogout(true);
      window.opener = null;
      window.open(urlAutoservice, "_self");
      window.close();
    } else {
      window.open(url, "_self");
    }
  };

  return (
    <Div
      sx={{
        flex: 1,
        marginTop: 15,
        flexWrap: "wrap",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: (theme) => theme.spacing(4),
      }}
    >
      <Box
        component="img"
        src={`${process.env.REACT_APP_IMAGES_PATH}/logo-${origen}.png`}
        sx={{
          justifyContent: "center",
          width: 350,
          height: 140,
        }}
      />
      {/* <Div sx={{mb: 3, display: 'inline-flex'}}>
                <Link
                    href="#"
                    underline="none"
                    sx={{display: 'inline-flex'}}
                >
                    <img src={`${ASSET_IMAGES}/logo.png`} alt="Jumbo React"/>
                </Link>
            </Div> */}
      <Card sx={{ maxWidth: "100%", width: 900, mb: 4 }}>
        <Div sx={{ position: "relative", height: "200px" }}>
          <CardMedia
            component="img"
            height="200"
            sx={{ backgroundColor: color }}
          />
          <Div
            sx={{
              flex: 1,
              inset: 0,
              position: "absolute",
              display: "flex",
              alignItems: "center",
              p: (theme) => theme.spacing(3),
            }}
          >
            <Typography
              variant={"h2"}
              sx={{
                color: "common.white",
                fontSize: "1.5rem",
                mb: 0,
              }}
            >
              Solicitud de Crédito - CI: {localStorage.getItem("cedula")}
            </Typography>
          </Div>
        </Div>
        <CardContent sx={{ pt: 0 }}>
          <>
            <br />
            <br />
            {idClienteInformacion > 0 && (
              <FormContactoCliente
                idCliente={idClienteInformacion}
                tipoDireccion="DIRDOM"
              />
            )}
          </>
          <Formik
            //validateOnChange={true}
            initialValues={{
              //email: "",
              cedula: localStorage.getItem("cedula"),
              //celular: "",
            }}
            //validationSchema={validationSchema}
            onSubmit={(data, { setSubmitting }) => {
              setSubmitting(true);
              //onSignIn(data.email, data.cedula, data.celular);
              onSignIn(data.cedula);
              setSubmitting(false);
            }}
          >
            {({ isSubmitting }) => (
              <Form style={{ textAlign: "left" }} noValidate autoComplete="off">
                {/* <Avatar
                  sx={{
                    width: 56,
                    height: 56,
                    marginLeft: "auto",
                    boxShadow: shadows[3],
                    transform: "translateY(-50%)",
                  }}
                /> */}
                {/* {mutation.isError && <p>{mutation.error.message}</p>}
                <Div sx={{ mb: 2, mt: 1, marginTop: 5 }}>
                  <JumboTextField
                    fullWidth
                    name="cedula"
                    label="Cedula"
                    //type="password"
                  />
                </Div> */}

                {/* <Div sx={{ mb: 3, mt: 1 }}>
                  <JumboTextField fullWidth name="email" label="Email" />
                </Div>
                <Div sx={{ mb: 2, mt: 1 }}>
                  <JumboTextField
                    fullWidth
                    name="celular"
                    label="Número Celular"
                  />
                </Div> */}

                <FormControl
                  required
                  error={error}
                  component="fieldset"
                  sx={{ m: 1 }}
                  variant="standard"
                >
                  <FormLabel component="legend">
                    Políticas de aceptación de servicio
                  </FormLabel>
                  <FormGroup>
                    <FormControlLabel
                      sx={{ alignItems: "flex-start", mb: 1 }}
                      control={
                        <Checkbox
                          sx={{
                            marginTop: -1,
                          }}
                          checked={uno}
                          onChange={handleChange}
                          name="uno"
                        />
                      }
                      label="Acepto los Términos y condiciones de uso"
                    />
                    <FormControlLabel
                      sx={{ alignItems: "flex-start", mb: 1 }}
                      control={
                        <Checkbox
                          sx={{
                            marginTop: -1,
                          }}
                          checked={dos}
                          onChange={handleChange}
                          name="dos"
                        />
                      }
                      label="Acepto los tratamientos de mis datos personales"
                    />
                    <FormControlLabel
                      sx={{ alignItems: "flex-start", mb: 2 }}
                      control={
                        <Checkbox
                          sx={{
                            marginTop: -1,
                          }}
                          checked={tres}
                          onChange={handleChange}
                          name="tres"
                        />
                      }
                      label="Autorizo a consultar referencias crediticias en el Buró de Crédito"
                    />
                  </FormGroup>
                  {/* <FormHelperText>You can display an error</FormHelperText> */}
                </FormControl>
                <LoadingButton
                  disabled={error}
                  fullWidth
                  type="submit"
                  variant="contained"
                  size="large"
                  sx={{ mb: 3 }}
                  loading={isSubmitting || mutation.isLoading}
                >
                  CONTINUAR
                </LoadingButton>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
      <Button
        size="lg"
        variant="outlined"
        startIcon={<HouseIcon />}
        onClick={() => handleRedirect()}
      >
        <Typography> Regresar a la pagina Principal</Typography>
      </Button>
    </Div>
  );
};

export default Welcome1;
